__webpack_public_path__ = window.__kbnPublicPath__['kbn-ui-shared-deps-npm']